// window onload function
$(window).on('load', async function () {
  const isAccountPage = window.location.pathname === '/account';

  if (!isAccountPage) return;
  /*=========================== TRACKING ORDER STATUS ==========================*/
  const currentOrdersWrapper = $('[data-orders-type="current"]');
  const historyOrdersWrapper = $('[data-orders-type="history"] .orders-ctn');
  const historyOrders = historyOrdersWrapper.children();
  const paginations = $('#OrdersHistory .pagination');
  const paginationArrows = $('.pagination--custom .pagination__arrow');
  const accountCTA = $('.account-customer .cta-card__wrapper');

  const currentOrders = currentOrdersWrapper.children('[data-tracking-order]');

  if (currentOrders.length > 0) {
    await getOrdersShippingStatus(currentOrders, historyOrdersWrapper);
  } else {
    currentOrdersWrapper.remove();
  }

  toggleLoading(
    currentOrdersWrapper,
    currentOrders,
    historyOrders,
    paginations,
    accountCTA
  );
  renderPagination(historyOrdersWrapper);

  paginationArrows.each(function () {
    $(this).on('click', function () {
      const page = $(this).attr('data-page');
      pagination(page);
    });
  });
});

const toggleLoading = (
  currentOrdersWrapper,
  currentOrders,
  historyOrders,
  paginations,
  accountCTA
) => {
  if (currentOrders.length == 0) {
    currentOrdersWrapper.remove();
    accountCTA.show();
  }
  if (historyOrders.length == 0) {
    $('#OrdersHistory').remove();
  }
  if (historyOrders.length <= 3) {
    paginations.remove();
  }
  $('.orders__wrapper').toggleClass('loading');
  $('.loading-spinner').toggleClass('loading-spinner--active-theme');
};

const getOrdersShippingStatus = async (orders, historyOrdersWrapper) => {
  // for (order of orders) {
  //   const trackingUrl = $(order).data('get-tracking');
  //   const trackingStatus = $(order).data('tracking-status');
  //   const trackingOrder = $(order).data('tracking-order');
  //   console.log(trackingUrl);

  //   if (!trackingUrl.includes('unfulfilled')) {
  //     const { StatusCode } = await getShippingStatus(trackingUrl);
  //     // set new status code
  //     $(order).data('tracking-status', StatusCode);

  //     // removes this from current orders wrapper if status code is 6
  //     if (StatusCode === 6 || StatusCode === 0) {
  //       $(order).remove();
  //     } else {
  //       // show status code banner of matching code
  //       $(order)
  //         .find(`.content[data-tracking-status="${StatusCode}"]`)
  //         .addClass('active');

  //       historyOrdersWrapper
  //         .find(`[data-tracking-order="${trackingOrder}"]`)
  //         .remove();
  //     }
  //   } else {
  //     $(order)
  //       .find(`.content[data-tracking-status="${trackingStatus}"]`)
  //       .addClass('active');

  //     historyOrdersWrapper
  //       .find(`[data-tracking-order="${trackingOrder}"]`)
  //       .remove();
  //   }
  // }
  return;
};

const getShippingStatus = async (trackingUrl) => {
  const response = await fetch(
    'https://gcp-test-backoffice-barkyn-56ri.encr.app/shipping/tracking/' +
      trackingUrl,
    {
      method: 'POST',
      body: '{"country": "Portugal"}', // string or object
      headers: {
        'Content-Type': 'application/json',
      },
    }
  );
  const myJson = await response.json(); //extract JSON from the http response
  
  // do something with myJson
  return myJson;
};

// Take a number of orders and find the number of pages needed to display them
const renderPagination = (ordersCtn) => {
  const count = ordersCtn.children().length;
  const pages = Math.ceil(count / 3);

  // for each child of ordersCtn, assign a page number
  ordersCtn.children().each(function (i) {
    $(this).attr('data-page-ref', Math.floor(i / 3));
    // hide all orders except the first 3
    if (i > 2) {
      $(this).hide();
    }
  });

  // add current page to next and previous arrows. Add total pages to next arrow and previous arrow
  $('.pagination__arrow--next').attr('data-page', 1).attr('data-total', pages);
  $('.pagination__arrow--previous')
    .attr('data-page', 0)
    .attr('data-total', pages)
    .hide();

  // if there is more than 1 page, render pagination
  if (pages > 1) {
    let pagination = '';
    for (let i = 0; i < pages; i++) {
      // create pagination link for each page that on click will show the corresponding orders with attribute data-page
      pagination += `<span class="page pagination__item" data-page="${i}"> <a href="#OrdersHistory" onclick="pagination(${i})">${
        i + 1
      }</a></span>`;
    }
    // append pagination to .pagination__container but before the next button
    $(pagination).insertBefore('.pagination__arrow--next');

    $('.pagination__item:first-of-type').addClass('current');
  }
};

const paginate = (e) => {
  const page = $(e).data('page');
  const paginateItems = $('[data-page-ref]');
  const paginateSpan = $(e).parent();

  // hide all orders
  paginateItems.hide();
  // show orders for selected page
  paginateItems
    .filter(function () {
      return $(this).data('page-ref') == page;
    })
    .show();
  // remove active class from all pagination links
  $('.pagination__item').removeClass('current');
  // add current class to selected pagination link
  paginateSpan.addClass('current');

  // update next and previous arrows with new page number
  $('.pagination__arrow--next').attr('data-page', page++);
  $('.pagination__arrow--prev').attr('data-page', page--);

  // hide next arrow if on last page
  if (page + 1 == $('.pagination__arrow--next').data('total')) {
    $('.pagination__arrow--next').hide();
  }

  // hide previous arrow if on first page
  if (page == 0) {
    $('.pagination__arrow--prev').hide();
  }
};

const arrowsPagination = (e) => {
  let page = $(e).attr('data-page');
  const paginateItems = $('[data-page-ref]');
  const paginates = $(`[data-page="${page}"]`);
  const type = $(e).attr('class').split(' ')[1].split('--')[1];
  const total = $(e).data('total');

  // hide all orders
  paginateItems.hide();
  // show orders for selected page
  paginateItems
    .filter(function () {
      return $(this).data('page-ref') == page;
    })
    .show();

  // remove active class from all pagination links
  $('.pagination__item').removeClass('current');
  // add current class to selected pagination link
  paginates.addClass('current');

  // hide next arrow if on last page
  if (type === 'next') {
    if (page == total) {
      $(e).hide();
    } else {
      $(e).show();
      page++;
      $(e).attr('data-page', page);
      console.log(page);
    }
    $('.pagination__arrow--previous').show();
  } else {
    if (page == 0) {
      $(e).hide();
    } else {
      $(e).show();
      page--;
      $(e).attr('data-page', page);
    }
  }
};

const pagination = (p) => {
  const page = parseInt(p);
  const paginateItems = $('[data-page-ref]');
  const paginates = $(`[data-page="${page}"]`);

  // hide all orders
  paginateItems.hide();
  // show orders for selected page
  paginateItems
    .filter(function () {
      return $(this).data('page-ref') == page;
    })
    .show();

  // remove active class from all pagination links
  $('.pagination__item').removeClass('current');
  // add current class to selected pagination link
  paginates.addClass('current');

  // hide next arrow if on last page
  if (page + 1 == $('.pagination__arrow--next').data('total')) {
    $('.pagination__arrow--next').hide();
  } else {
    $('.pagination__arrow--next').show();
  }

  // hide previous arrow if on first page
  if (page == 0) {
    $('.pagination__arrow--previous').hide();
  } else {
    $('.pagination__arrow--previous').show();
  }

  // update next and previous arrows with new page number
  $('.pagination__arrow--previous').attr('data-page', page - 1);
  $('.pagination__arrow--next').attr('data-page', page + 1);
  console.log(page);
};
